<template>
  <div>
    <LayoutHeader />
    <SliderArea />
    <AboutArea />
    <PopularCourses :showTheme="false" />
    <TestimonialArea />
    <CourseSpeciality />
    <FooterArea />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import LayoutHeader from "./Header.vue";
import SliderArea from "./SliderArea.vue";
import AboutArea from "./about/AboutArea.vue";
import PopularCourses from "./courseShop/PopularCourses.vue";
import TestimonialArea from "./about/TestimonialArea.vue";
import CourseSpeciality from "./about/CourseSpeciality";
import FooterArea from "./FooterArea";
import "@/assets/style/css/common.css";

export default defineComponent({
  components: {
    LayoutHeader,
    SliderArea,
    AboutArea,
    PopularCourses,
    TestimonialArea,
    CourseSpeciality,
    FooterArea,
  },
  setup() {},
});
</script>
